import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import { offlineDB } from "../offline/db";

import "../print/thermal.css";
import "../print/a4.css";

const PrintInvoice = () => {
  const navigate = useNavigate();
  const { invoiceId } = useParams();
  const [invoice, setInvoice] = useState(null);

  const printerType =
    localStorage.getItem("printerType") || "THERMAL";

  const isOffline =
    window.location.pathname.includes("/offline/");

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        /* ================= OFFLINE ================= */
        if (isOffline) {
          const offlineId = Number(invoiceId);
          if (!offlineId) {
            alert("Invalid offline invoice");
            return;
          }

          const data = await offlineDB.invoices.get(offlineId);
          if (!data) {
            alert("Offline invoice not found");
            return;
          }

          let taxable_total = 0;
          let cgst_total = 0;
          let sgst_total = 0;

          const items = data.items.map(i => {
            const gst =
              data.bill_type === "GST"
                ? Number(i.gst_percent || 0)
                : 0;

            const total = Number(i.total);
            const taxable =
              gst > 0 ? (total * 100) / (100 + gst) : total;

            const gstAmt = total - taxable;

            taxable_total += taxable;
            cgst_total += gstAmt / 2;
            sgst_total += gstAmt / 2;

            return {
              product_name: i.product_name,
              quantity: i.quantity,
              rate: i.price,
              taxable: taxable.toFixed(2),
              cgst: (gstAmt / 2).toFixed(2),
              sgst: (gstAmt / 2).toFixed(2),
              gst_percent: gst,
              total: total.toFixed(2)
            };
          });

          setInvoice({
            invoice_number: `OFF-${offlineId}`,
            invoice_date: data.created_at,
            payment_mode: data.payment_mode,
            customer_name: data.customer_name,
            customer_mobile: data.customer_mobile,
            bill_type: data.bill_type || "NONGST",
            branch: data.branch,
            items,
            total_quantity: items.reduce(
    (s, i) => s + Number(i.quantity),
    0
  ),
  subtotal: data.subtotal,
  discount_type: data.discount_type,
  discount_value: data.discount_value,
  discount_amount: data.discount_amount,
  grand_total: data.grand_total,
            taxable_total: taxable_total.toFixed(2),
            cgst_total: cgst_total.toFixed(2),
            sgst_total: sgst_total.toFixed(2),
          }); 

          setTimeout(() => window.print(), 400);
        }

        /* ================= ONLINE ================= */
        else {
          const res = await api.get(`/pos/invoice/${invoiceId}`);
          setInvoice(res.data);
          setTimeout(() => window.print(), 400);
        }

        // auto back after print
        setTimeout(() => navigate(-1), 600);
      } catch (err) {
        console.error("PRINT ERROR:", err);
        alert("Failed to load invoice");
      }
    };

    fetchInvoice();
  }, [invoiceId, isOffline, navigate]);

  if (!invoice || !invoice.items?.length) {
    return <p>Loading invoice...</p>;
  }
console.log(invoice);
  return (
    <div
      className={
        printerType === "THERMAL"
          ? "thermal-page"
          : "a4-page"
      }
    >
      {/* ================= HEADER ================= */}
      <div className="center bold">
        {invoice.branch?.branch_name}
      </div>

      {invoice.branch?.address && (
        <div className="center">
          {invoice.branch.address}
        </div>
      )}

      {invoice.branch?.mobile && (
        <div className="center">
          Ph: {invoice.branch.mobile}
        </div>
      )}

      {invoice.bill_type === "GST" && (
        <div className="center">
          GSTIN: {invoice.branch?.gstin}
        </div>
      )}

      <hr />

      {/* ================= META ================= */}
      <div>
        <b>Invoice No:</b> {invoice.invoice_number}
      </div>

      <div>
        <b>Date:</b>{" "}
        {new Date(invoice.invoice_date).toLocaleString()}
      </div>

      <div>
        <b>Payment:</b> {invoice.payment_mode}
      </div>

      <div>
  <b>Billed By:</b>{" "}
  {invoice.created_by_name || "Staff"}
</div>

      {invoice.customer_name && (
        <div>
          <b>Customer:</b> {invoice.customer_name}
        </div>
      )}

      {isOffline && (
        <div className="center bold">
          ** OFFLINE INVOICE **
        </div>
      )}

      <hr />

      {/* ================= ITEMS ================= */}
      {printerType === "THERMAL" ? (
        <>
          <table width="100%">
            <thead>
              <tr>
                <th align="left">Item</th>
                <th align="right">Qty</th>
                <th align="right">Amt</th>
              </tr>
            </thead>
            <tbody>
              {invoice.items.map((i, idx) => (
                <tr key={idx}>
                  <td>{i.product_name}</td>
                  <td align="right">{i.quantity}</td>
                  <td align="right">{i.total}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <hr />

          {invoice.bill_type === "GST" && (
  <>
    <div>Taxable : ₹{invoice.taxable_total}</div>
    <div>CGST : ₹{invoice.cgst_total}</div>
    <div>SGST : ₹{invoice.sgst_total}</div>
  </>
)}

<div>
  <b>Total Qty:</b> {invoice.total_quantity}
</div>

<hr />

<div>Subtotal : ₹{invoice.subtotal}</div>

{invoice.discount_amount > 0 && (
  <div>
    Discount{" "}
    {invoice.discount_type === "PERCENT"
      ? `(${invoice.discount_value}%)`
      : ""}
    : -₹{invoice.discount_amount}
  </div>
)}

<hr />

<div className="bold">
  TOTAL : ₹{invoice.grand_total}
</div>


        </>
      ) : (
        <>
          <table width="100%" border="1" cellPadding="6">
            <thead>
              <tr>
                <th>#</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Taxable</th>
                <th>CGST</th>
                <th>SGST</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {invoice.items.map((i, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{i.product_name}</td>
                  <td align="right">{i.quantity}</td>
                  <td align="right">{i.rate}</td>
                  <td align="right">{i.taxable}</td>
                  <td align="right">{i.cgst}</td>
                  <td align="right">{i.sgst}</td>
                  <td align="right">{i.total}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {invoice.bill_type === "GST" && (
            <table width="100%" style={{ marginTop: 10 }}>
              <tbody>
                <tr>
                  <td align="right"><b>Taxable</b></td>
                  <td align="right">₹{invoice.taxable_total}</td>
                </tr>
                <tr>
                  <td align="right"><b>CGST</b></td>
                  <td align="right">₹{invoice.cgst_total}</td>
                </tr>
                <tr>
                  <td align="right"><b>SGST</b></td>
                  <td align="right">₹{invoice.sgst_total}</td>
                </tr>
              </tbody>
            </table>
          )}

          <div className="bold center" style={{ marginTop: 10 }}>
            GRAND TOTAL : ₹{invoice.grand_total}
          </div>
        </>
      )}

      <hr />

      <div className="center">
        Thank you! Visit Again 🙏
      </div>
    </div>
  );
};

export default PrintInvoice;
